import * as req from 'api/actions';
import * as c from './constant';

export const getTotalStats = (payload, callback) =>
  req.item(
    c.GET_TOTAL_STATS,
    'api/v1/administrators/cash_in/statistics',
    payload,
    callback
  );

export const getGraphStats = (
  payload,
  callback
) =>
  req.list(
    c.GET_GRAPH_STATS,
    'api/v1/administrators/cash_in/graph',
    payload,
    callback
  );
